import SectionViewSwitch, { Props } from './SectionViewSwitch';
export default SectionViewSwitch;
export type Props = Props;
